import { BaseGQLService } from '../../common/services/BaseGQLService';

export const VERSION_QUERY = `
{
  version
}
`;

export class VersionService extends BaseGQLService {
  async getVersion(): Promise<string> {
    return this.query(VERSION_QUERY, {}, (data) => data.version);
  }
}
